import { withTranslation } from "react-i18next";
import WithRouter from "../../../../components/Common/WithRouter";
import React, { createRef, useRef, useState } from "react";
import { Field, Form, Formik, FormikProps } from "formik";
import { Col, Row } from "react-bootstrap";
import InputDateTime from "../../../../components/Shared/InputDateTime";
import { Button } from "primereact/button";
import { request } from "../../../../utils/Request";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from "moment-timezone";
import { InputField } from "../../../../components/Shared/InputField";
import { ButtonGroup } from "primereact/buttongroup";
import { InputSelectField } from "../../../../components/Shared/InputSelectField";
import ReadMore from "../../../../components/Common/Display/ReadMore";
import * as yup from "yup";
import { sumBy } from "lodash";

type TInputForm = {
    toDate: null,
    fromDate: null,
    from_location_ids: null,
    to_location_ids: null,
    clients_ids: null,
    number_of_vehicles: null,
};

const DEFAULT_FORM_STATE = {
    fromDate: moment().startOf('month').format("YYYY-MM-DD 00:00:00"),
    toDate: moment().endOf('month').format("YYYY-MM-DD 23:59:59"),
    from_location_ids: [],
    to_location_ids: [],
    clients_ids: [],
    legal_entity_ids: [],
    number_of_vehicles: null,
};

const validationSchema = (t: Function): any => {
    return yup.object().shape({
        fromDate: yup.string().required(t('the field is required.', { field: t('from date') })).nullable(),
        toDate: yup.string().required(t('the field is required.', { field: t('to date') })).nullable(),
        from_location_ids: yup.array().required(t('the field is required.', { field: t('from location') })).nullable(),
        to_location_ids: yup.array().required(t('the field is required.', { field: t('to location') })).nullable(),
        clients_ids: yup.array().nullable(),
        legal_entity_ids: yup.array().nullable(),
        number_of_vehicles: yup.number().nullable(),
    });
};

const AnalyticsVehicleReportList = (props: any) => {
    const { t, moduleState, dropdowns, toastify } = props;
    const [filterPanel, setFilterPanel] = useState<boolean>(true);
    const [collection, setCollection] = useState<any>([]);
    const [initFormState, setInitFormState] = useState<any>(DEFAULT_FORM_STATE);
    const dt = createRef<any>();
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const [initSearchFormState, setInitSearchFormState] = useState<any>({
        search: moduleState.search ?? null
    });

    const formRef: any = useRef();

    const onReset = (reset: any = true) => {
        const mStates = { ...moduleState };

        if ( reset ) {
            mStates.filters = [];
            mStates.page = 1;
            mStates.search = null;
        }

        props.setQuery(mStates);
    };

    const onFilterClick = () => setFilterPanel(!filterPanel);

    const focusOnSearch = () => {
        const searchInput: HTMLInputElement | null = document.querySelector('input[name="search"]');
        if ( searchInput ) {
            searchInput.focus();
        }
    };

    const onSubmit = async (payloads: TInputForm, { setErrors, resetForm }: any) => {
        try {
            const response = await request({
                url: '/suppliers/reports/vehicles',
                method: 'POST',
                data: {
                    ...payloads,
                }
            });

            const { data } = response.data;
            setCollection(data);
        } catch (e: any) {
            if ( e.status === 422 ) {
                setErrors(e.data.errors);
            } else {
                toastify(t("server error"), "error");
            }
        }
    };

    const onSearch = ({ search }: any) => {
        setGlobalFilter(search);
    };

    // useEffect(() => {
    //     async function init() {
    //         await onSubmit({ ...DEFAULT_FORM_STATE });
    //     }
    //
    //     init();
    // }, []);

    const onDownloadExcelClick = () => {
        // @ts-ignore
        return dt.current.exportCSV();
    };

    return (
        <div>
            <div className={ "block-viewer" }>
                <div className={ !filterPanel ? 'hidden' : '' }>
                    <div className="block-section mb-3">
                        <Formik
                            innerRef={ formRef }
                            enableReinitialize={ true }
                            initialValues={ initFormState }
                            onSubmit={ onSubmit }
                            validationSchema={ validationSchema(t) }
                        >
                            { (props: FormikProps<TInputForm>) => {
                                return (
                                    <Form onSubmit={ props.handleSubmit }>
                                        <div className="block-header p-3">
                                            <span className="block-title">
                                                <h5 className={ "mb-0" }>{ t('filters') }</h5>
                                            </span>
                                            <div className="block-actions">
                                                <Button type={ "submit" } disabled={ props.isSubmitting }
                                                        tooltip={ t("to data save into database") }
                                                        size={ "small" }
                                                        tooltipOptions={ { position: 'top' } }
                                                >
                                                    <i className="pi pi-filter me-2" />
                                                    { t("filter") }
                                                </Button>
                                                <Button type={ "button" } disabled={ props.isSubmitting }
                                                        onClick={ onReset }
                                                        tooltip={ t("to make all fields empty") } className={ "ms-2" }
                                                        size={ "small" } severity={ "warning" }
                                                        tooltipOptions={ { position: 'top' } }
                                                >
                                                    <i className="pi pi-refresh me-2" />
                                                    { t("reset") }
                                                </Button>
                                            </div>
                                        </div>

                                        <div className="block-content">
                                            <div className="card" style={{border:0, borderRadius: 0}}>
                                                <div className="card-body">
                                                    <Row>
                                                        <Col sm={ 12 } md={ 3 }>

                                                            <Field component={ InputDateTime }
                                                                   name="fromDate"
                                                                   type={ "datetime" }
                                                                   label={ t("from date") }
                                                                   isClearable={ true }
                                                                   isRequired
                                                                   enableTimeStartOfDay
                                                            />
                                                        </Col>
                                                        <Col sm={ 12 } md={ 3 }>
                                                            <Field component={ InputDateTime }
                                                                   name="toDate"
                                                                   type={ "datetime" }
                                                                   label={ t("to date") }
                                                                   isClearable={ true }
                                                                   enableTimeEndOfDay
                                                                   isRequired
                                                            />
                                                        </Col>
                                                        <Col sm={ 12 } md={ 3 }>
                                                            <Field component={ InputSelectField }
                                                                   options={ dropdowns.locations }
                                                                   name="from_location_ids"
                                                                   isRequired
                                                                   placeholder={ t("select") + ' ' + t("from location") }
                                                                   label={ t('from locations') } />
                                                        </Col>
                                                        <Col sm={ 12 } md={ 3 }>
                                                            <Field component={ InputSelectField }
                                                                   options={ dropdowns.locations }
                                                                   name="to_location_ids"
                                                                   isRequired
                                                                   placeholder={ t("select") + ' ' + t("to location") }
                                                                   label={ t('to locations') } />
                                                        </Col>
                                                        <Col sm={ 12 } md={ 3 }>
                                                            <Field component={ InputSelectField }
                                                                   options={ dropdowns.legalEntities }
                                                                   name="legal_entity_ids"
                                                                   placeholder={ t("select") + ' ' + t("legal entity") }
                                                                   label={ t('legal entities') } />
                                                        </Col>
                                                        <Col sm={ 12 } md={ 3 }>
                                                            <Field component={ InputSelectField }
                                                                   options={ dropdowns.clients }
                                                                   name="client_ids"
                                                                   placeholder={ t("select") + ' ' + t("clients") }
                                                                   label={ t('clients') } />
                                                        </Col>
                                                        <Col sm={ 12 } md={ 3 }>
                                                            <Field component={ InputField }
                                                                   name="number_of_vehicles"
                                                                   label={ t("number of vehicles") +' (>=)' }
                                                                   placeholder={ t("enter") + ' ' + t("number").toLowerCase() } />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                );
                            } }
                        </Formik>
                    </div>
                </div>
            </div>

            <div className={ "block-viewer" }>
                <div className="block-section">
                    <div className="block-header p-3">
                        <div className="block-title">
                            <h5 className={ "mb-0" }>
                                { t('vehicles') }
                                ({ sumBy(collection, 'number_of_vehicles') })
                            </h5>
                        </div>
                    </div>

                    <div className="block-content">
                        <div className={ "p-2 row" }>
                            <Col
                                sm={ 12 } md={ 6 } className={ "mb-2" }>
                                <Formik
                                    enableReinitialize={ true }
                                    initialValues={ initSearchFormState }
                                    onSubmit={ onSearch }
                                >
                                    { (props: FormikProps<any>) => {
                                        return (
                                            <Form onSubmit={ props.handleSubmit }>
                                                <Col sm={ 12 } md={ 8 }>
                                                    <Field component={ InputField } withoutLabel={ true }
                                                           autoFocus={ true }
                                                           name="search"
                                                           formGroupClass={ "mb-0" }
                                                           placeholder={ t("search") } />
                                                </Col>
                                            </Form>
                                        );
                                    } }
                                </Formik>
                            </Col>

                            <Col
                                sm={ 12 } md={ 6 } className={ "text-right mb-2" }>
                                <ButtonGroup>
                                    <Button icon="pi pi-filter-fill" size={ "small" } outlined tooltip={ t('filter') }
                                            onClick={ onFilterClick }
                                            tooltipOptions={ { position: 'top' } } />
                                    <Button icon="pi pi-file-excel" size={ "small" } outlined
                                            tooltip={ t('download excel') }
                                            onClick={ onDownloadExcelClick }
                                            tooltipOptions={ { position: 'top' } } />
                                </ButtonGroup>
                            </Col>

                            <div className="col-sm-12">
                                <DataTable
                                    ref={ dt }
                                    globalFilter={ globalFilter }
                                    value={ collection }
                                    showGridlines
                                    sortMode="multiple"
                                    resizableColumns
                                    columnResizeMode="fit"
                                >
                                    <Column
                                        field="route_title"
                                        header={ t('route') }
                                        sortable
                                        filter
                                        filterPlaceholder={ t("search") }
                                        body={ (rowData) => <span>{ rowData.route_title }</span> }
                                    />
                                    <Column
                                        field="number_of_vehicles"
                                        header={ t('number of vehicles') }
                                        sortable
                                        filter
                                        filterPlaceholder={ t("search") }
                                        body={ (rowData) => <span>{ rowData.number_of_vehicles }</span> }
                                    />
                                    <Column
                                        field="client"
                                        header={ t('client') }
                                        sortable
                                        filter
                                        filterPlaceholder={ t("search") }
                                        body={ (rowData) => <ReadMore text={ rowData.client } limit={ 3 } /> }
                                    />
                                    <Column
                                        field="load_number"
                                        header={ t('load number') }
                                        sortable
                                        filter
                                        filterPlaceholder={ t("search") }
                                        body={ (rowData) => <ReadMore text={ rowData.load_number } limit={ 3 } /> }
                                    />
                                    <Column
                                        field="vin_number"
                                        header={ t('vin number') }
                                        sortable
                                        filter
                                        filterPlaceholder={ t("search") }
                                        body={ (rowData) => <ReadMore text={ rowData.vin_number } limit={ 3 } /> }
                                    />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AnalyticsVehicleReportList.propTypes = {
    // t: PropTypes.any,
};

export default withTranslation()(WithRouter(AnalyticsVehicleReportList));
